import React from "react";
import LoginForm from "../components/LoginForm";
import Footer from '../components/Footer';
import "./resources.css";

function Profile () {
    return (
        <div>
            <LoginForm />
            <Footer />
        </div>
    );
}
export default Profile;
